import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function NotFound() {
  return (
    <div className="min-h-screen grain flex items-center justify-center px-4" data-testid="not-found">
      <div className="relative z-10 w-full max-w-md text-center reveal">
        <div className="flex justify-center">
          <Logo size="md" testId="notfound-logo" />
        </div>
        <p className="mt-10 font-mono-x text-sm text-slate-400">404</p>
        <h1 className="mt-2 text-3xl font-extrabold">There's nothing here</h1>
        <p className="mt-3 text-sm text-slate-500">
          The link may be old, or mistyped. Everything else is still where you left it.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="notfound-home"
            className="px-6 py-3 rounded-full bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800 transition-colors"
          >
            Go home
          </Link>
          <Link
            to="/login"
            data-testid="notfound-login"
            className="px-6 py-3 rounded-full border border-slate-300 text-sm font-semibold text-slate-700 hover:border-slate-500 transition-colors"
          >
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
